
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/quoting",
      function () {
        return require("private-next-pages/solutions/quoting/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/quoting"])
      });
    }
  